import {
  RangesIcon,
  TooltipDesc,
  TooltipInfo,
  TooltipName,
} from "components/base/Tooltip";
import { getStatRangeData } from "libs/stats";
import { StatRangeData, StatRanges } from "types";
import {
  StatIconWrapper,
  TooltipStatRangeValues,
  TooltipTotalStat,
  TotalStatName,
} from "./DerivedStatsBase";

interface TooltipStatsProps {
  slug: keyof StatRanges;
  statRange: StatRangeData;
  baseRange: StatRangeData;
  upgradesRange: StatRangeData;
}

const TooltipDerivedStatRange = ({
  slug,
  statRange,
  baseRange,
  upgradesRange,
}: TooltipStatsProps) => {
  const statRangeSlug = slug as keyof StatRanges;
  const statRangeInfo = getStatRangeData(statRangeSlug);

  return (
    <>
      <TooltipName>{statRangeInfo.name}</TooltipName>
      <TooltipDesc>{statRangeInfo.description}</TooltipDesc>
      <TooltipInfo>
        <TooltipStatRangeValues $color={statRangeInfo.color}>
          {`Base Range: ${statRangeInfo.formatter(
            baseRange.min,
            baseRange.max
          )}`}
        </TooltipStatRangeValues>
        <TooltipStatRangeValues $color={statRangeInfo.color}>
          {`Upgrade Bonus: ${statRangeInfo.addFormatter(
            upgradesRange.min,
            upgradesRange.max
          )}`}
        </TooltipStatRangeValues>
        <TooltipTotalStat>
          <TooltipStatRangeValues $color={statRangeInfo.color}>
            <StatIconWrapper>
              {statRangeInfo.images.map((image) => (
                <RangesIcon key={image} image={image} />
              ))}
            </StatIconWrapper>
            <div>
              <TotalStatName>Total Range: </TotalStatName>
              {statRangeInfo.formatter(statRange.min, statRange.max)}
            </div>
          </TooltipStatRangeValues>
        </TooltipTotalStat>
      </TooltipInfo>
    </>
  );
};

export default TooltipDerivedStatRange;
